module.exports = __webpack_public_path__ + "/login_ui/img/kw-7f56ef569ab061f50bd4dbb3e19dd9e5.svg";